<template>
  <div class="m-1">
    <Input
      :label="$t('href')"
      :value="options.href"
      @enter="propChanged('href', $event)"
      @blur="propChanged('href', $event)"
    />

    <span>{{ $t('target') }}</span>
    <Dropdown :options="targetOptions" :value="options.target" @change="propChanged('target', $event)" />

    <Input
      :label="$t('content')"
      :value="options.text.content"
      @enter="propChanged('text.content', $event)"
      @blur="propChanged('text.content', $event)"
    />

    <span>{{ $t('font-size') }} (px)</span>
    <PlacementNumber :initial="options.text.size" @change="propChanged('text.size', $event)" />

    <hr />
    <div class="advanced-collapsible__item">
      <FontStyleButton text="text" :values="options.text" @change="propChanged($event.path, $event.value)" />
    </div>
    <hr />

    <p>{{ $t('text-color') }}</p>
    <div class="d-flex justify-content-around">
      <ColorPicker :label="$t('normal')" :color="options.text.default" @submit="propChanged('text.default', $event)" />
      <ColorPicker
        :label="$t('hover')"
        :color="options.text.hover"
        open-direction="left"
        @submit="propChanged('text.hover', $event)"
      />
    </div>

    <p>{{ $t('background-color') }}</p>
    <div class="d-flex justify-content-around">
      <ColorPicker
        :label="$t('normal')"
        :color="options.background.default"
        @submit="propChanged('background.default', $event)"
      />
      <ColorPicker
        :label="$t('hover')"
        :color="options.background.hover"
        open-direction="left"
        @submit="propChanged('background.hover', $event)"
      />
    </div>

    <Border :border="options.border" @change="propChanged(`border.${$event.field}`, $event.value)" />

    <Spacement
      :label="$t('padding')"
      :options="options.padding"
      @change="propChanged(`padding.${$event.field}`, $event.value)"
    />
  </div>
</template>

<script>
import WidgetSideNavMixin from './Mixin.js'
import FontStyleMixin from '@/mixins/FontStyleMixin'
import FontStyleButton from '@/shared/components/FontStyleButton'

export default {
  name: 'ButtonSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel.widget.cta-button-side-nav' },
  mixins: [WidgetSideNavMixin, FontStyleMixin],
  components: { FontStyleButton },
  computed: {
    targetOptions() {
      return [
        {
          value: '_blank',
          text: this.$i18n.t('components.sidenav.landing.panel.widget.cta-button-side-nav.open-new-tab'),
        },
        { value: '', text: this.$i18n.t('components.sidenav.landing.panel.widget.cta-button-side-nav.open-same-tab') },
      ]
    },
  },
}
</script>
